// extracted by mini-css-extract-plugin
export default {"btn":"ticketAreaButton__btn__wYlJB","disabled":"ticketAreaButton__disabled__XR2su"};